import { render, staticRenderFns } from "./NewChatDrivers.vue?vue&type=template&id=13e6a764"
import script from "./NewChatDrivers.vue?vue&type=script&lang=js"
export * from "./NewChatDrivers.vue?vue&type=script&lang=js"
import style0 from "./NewChatDrivers.vue?vue&type=style&index=0&id=13e6a764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports